import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { RegDocFieldsForDocFormFragmentDoc } from '../../../fragments/regDocFieldsForDocForm.generated';
import { FieldsToSelectRegDocInDocFormFragmentDoc } from '../../../fragments/fieldsToSelectRegDocInDocForm.generated';
import { MarketNamingTemplateFieldsFragmentDoc } from '../../../fragments/marketNamingTemplateFields.generated';
import { UserFieldsFragmentDoc } from '../../../fragments/userFields.generated';
import { ParagraphFieldsFragmentDoc } from '../../../fragments/paragraphFields.generated';
import { HistoryFieldsFragmentDoc } from '../../../fragments/historyFields.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRegulatoryDocumentDetailsQueryVariables = Types.Exact<{
  regulatoryDocumentId: Types.Scalars['ID'];
}>;


export type GetRegulatoryDocumentDetailsQuery = { __typename?: 'Query', regulatoryDocument?: { __typename?: 'RegulatoryDocument', id: string, createdAt?: any | null, modifiedAt?: any | null, status: Types.RegulatoryDocumentStatus, disassemblyStatus: Types.RegulatoryDocumentDisassemblyStatus, name: string, summary?: string | null, documentStatus: Types.DocumentStatus, getexLink?: string | null, modelYear?: number | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, dateEffective?: any | null, dateExpiration?: any | null, origin: Types.Origin, pogisExists: boolean, clearingAuditLogs: Array<{ __typename?: 'AuditLog', id: string }>, modifiedBy: { __typename?: 'User', id: string }, createdBy: { __typename?: 'User', id: string }, finalVersionRef?: { __typename?: 'RegulatoryDocument', id: string } | null, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null, vkos: Array<{ __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }>, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }> }>, regulation?: { __typename?: 'Regulation', id: string, name: string, regulationNumber: string, regulatoryDocuments: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus } }>, markets: Array<{ __typename?: 'Market', id: string, name: string, regulationNamingTemplates: Array<{ __typename?: 'NamingTemplate', template: string, description: string }>, regulatoryDocumentNamingTemplates: Array<{ __typename?: 'NamingTemplate', template: string, description: string }> }> } | null, childrenRefs?: Array<{ __typename?: 'RegulatoryDocument', id: string }> | null, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus, message?: string | null, processingVKO: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, processingVKOExternal: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, clearingVKO: Array<{ __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }>, reapprovingVKO: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, processingAuthor: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, reapprovingAuthor: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }, comments?: Array<{ __typename?: 'Commentary', id: string, comment?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null, faqs?: Array<{ __typename?: 'Faq', id: string, question?: string | null, answer?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null, phaseIn: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }>, phaseOut: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }>, predecessors?: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string }> | null, pogisDocuments: Array<{ __typename?: 'PogisDocument', id: string, pogisId: string }>, documentReferences?: Array<{ __typename?: 'DocumentReference', referenceDocumentType?: string | null, documentReferenceGroup: { __typename?: 'ReferenceGroup', selectAllRegulatoryDocuments: boolean, regulatoryDocumentReferences?: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, regulation?: { __typename?: 'Regulation', id: string } | null } | null> | null, regulationReference?: { __typename?: 'Regulation', id: string, name: string, regulationNumber: string } | null }, reference?: { __typename?: 'Reference', id: string, name: string } | null, referencedByDocuments: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, regulation?: { __typename?: 'Regulation', id: string, regulationNumber: string } | null }> }> | null, documentSource?: { __typename?: 'DocumentSource', id: string, name: string } | null, topicManagementSummary?: { __typename?: 'TopicManagementSummary', quarter: Types.TopicManagementSummaryQuarter, year: number } | null, predecessor?: { __typename?: 'RegulatoryDocument', id: string, name: string } | null, successor?: { __typename?: 'RegulatoryDocument', id: string, name: string } | null, document?: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string } | null, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null } | null };

export type GetAuditLogEntityInfoQueryVariables = Types.Exact<{
  endCursor?: Types.InputMaybe<Types.Scalars['String']>;
  fieldsFilter: Array<Types.StringOperationFilterInput> | Types.StringOperationFilterInput;
}>;


export type GetAuditLogEntityInfoQuery = { __typename?: 'Query', auditLogs?: { __typename?: 'AuditLogsConnection', nodes?: Array<{ __typename?: 'AuditLog', entityId: string, entity?: { __typename?: 'ActiveTypeMarket', id: string } | { __typename?: 'AttachmentCategory', id: string } | { __typename?: 'AuditLog', id: string } | { __typename?: 'BodyworkVariant', id: string } | { __typename?: 'Category', id: string } | { __typename?: 'Convolute', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'DocumentSource', id: string } | { __typename?: 'DriveVariant', id: string } | { __typename?: 'EngineVariant', id: string } | { __typename?: 'GdprRule', id: string } | { __typename?: 'GearboxVariant', id: string } | { __typename?: 'GetexRegulation', id: string } | { __typename?: 'GlobalAnnouncement', id: string } | { __typename?: 'IcsCode', id: string } | { __typename?: 'Keyword', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'PermissionGroup', id: string } | { __typename?: 'PogisDocument', id: string } | { __typename?: 'Question', id: string } | { __typename?: 'QuestionCategory', id: string } | { __typename?: 'Reference', id: string } | { __typename?: 'Regulation', id: string } | { __typename?: 'RegulationCluster', id: string } | { __typename?: 'RegulatoryDocument', id: string } | { __typename?: 'Requirement', id: string } | { __typename?: 'Simulation', id: string } | { __typename?: 'SimulationVehicleProject', id: string } | { __typename?: 'StandardPlusPcmsCluster', id: string } | { __typename?: 'Subscription', id: string } | { __typename?: 'SystemLevel', id: string } | { __typename?: 'Tag', id: string } | { __typename?: 'User', id: string } | { __typename?: 'VehicleCategory', id: string } | { __typename?: 'VehicleProject', id: string } | { __typename?: 'VexCluster', id: string } | { __typename?: 'Vko', id: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type GetVexRegulatoryDocumentParagraphsQueryVariables = Types.Exact<{
  regulatoryDocumentId: Types.Scalars['ID'];
  inProcess: Types.Scalars['Boolean'];
}>;


export type GetVexRegulatoryDocumentParagraphsQuery = { __typename?: 'Query', vexRegulatoryDocumentParagraphs: Array<{ __typename?: 'RegulatoryDocumentParagraph', page: number, createdAt?: any | null, modifiedAt?: any | null, id: string, modelYear?: number | null, comprehensive?: any | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, summary?: string | null, level: number, enumeration: string, isFootnote: boolean, position: number, changeInfoType: Types.ChangeInfoType, keywordAssignments?: Array<{ __typename?: 'KeywordAssignment', keyword: { __typename?: 'Keyword', id: string, name: string }, vexClusterAssignments: Array<{ __typename?: 'VexClusterAssignment', keywordStatus: Types.KeywordStatus, vexCluster: { __typename?: 'VexCluster', id: string, name: string }, keywordSuggestions?: Array<{ __typename?: 'KeywordSuggestion', suggestionNote: string, keyword: { __typename?: 'Keyword', id: string, name: string, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null } }> | null }> }> | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, elements: Array<{ __typename?: 'RegulatoryDocumentParagraphElement', type: Types.ParagraphElementType, text?: string | null, isHeader: boolean, page: number, bounds?: Array<number> | null, textPosition?: Types.TextPosition | null, asset?: { __typename?: 'BlobRef', contentType: string, fileName: string, uri: any } | null }>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, comments?: Array<{ __typename?: 'Commentary', id: string, comment?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null, faqs?: Array<{ __typename?: 'Faq', id: string, question?: string | null, answer?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, categories: Array<{ __typename?: 'Category', id: string, name: string }>, phaseIn?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, phaseOut?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, requirements: Array<{ __typename?: 'Requirement', id: string, name: string, requirementId?: string | null }> }> };

export type GetAuditLogsQueryVariables = Types.Exact<{
  entityId: Types.Scalars['String'];
  endCursor?: Types.InputMaybe<Types.Scalars['String']>;
  fieldsFilter: Array<Types.StringOperationFilterInput> | Types.StringOperationFilterInput;
}>;


export type GetAuditLogsQuery = { __typename?: 'Query', auditLogs?: { __typename?: 'AuditLogsConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename: 'AuditLog', entityId: string, entityNodeId: string, changeSetId: any, entityType: string, entityOperation: Types.EntityOperation, createdAt: any, id: string, entity?: { __typename: 'ActiveTypeMarket', id: string } | { __typename: 'AttachmentCategory', id: string } | { __typename: 'AuditLog', id: string } | { __typename: 'BodyworkVariant', id: string } | { __typename: 'Category', id: string } | { __typename: 'Convolute', id: string } | { __typename: 'Country', id: string } | { __typename: 'DocumentSource', id: string } | { __typename: 'DriveVariant', id: string } | { __typename: 'EngineVariant', id: string } | { __typename: 'GdprRule', id: string } | { __typename: 'GearboxVariant', id: string } | { __typename: 'GetexRegulation', id: string } | { __typename: 'GlobalAnnouncement', id: string } | { __typename: 'IcsCode', id: string } | { __typename: 'Keyword', id: string } | { __typename: 'Market', id: string } | { __typename: 'PermissionGroup', id: string } | { __typename: 'PogisDocument', id: string } | { __typename: 'Question', id: string } | { __typename: 'QuestionCategory', id: string } | { __typename: 'Reference', id: string } | { __typename: 'Regulation', id: string } | { __typename: 'RegulationCluster', id: string } | { __typename: 'RegulatoryDocument', id: string } | { __typename: 'Requirement', id: string } | { __typename: 'Simulation', id: string } | { __typename: 'SimulationVehicleProject', id: string } | { __typename: 'StandardPlusPcmsCluster', id: string } | { __typename: 'Subscription', id: string } | { __typename: 'SystemLevel', id: string } | { __typename: 'Tag', id: string } | { __typename: 'User', id: string } | { __typename: 'VehicleCategory', id: string } | { __typename: 'VehicleProject', id: string } | { __typename: 'VexCluster', id: string } | { __typename: 'Vko', id: string } | null, change: { __typename: 'AuditLogChange', value?: any | null, oldValue?: any | null, nodeId?: string | null, oldNodeId?: string | null, type: string, key: string, path: string, valueType?: string | null }, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null } | null };


export const GetRegulatoryDocumentDetailsDocument = gql`
    query GetRegulatoryDocumentDetails($regulatoryDocumentId: ID!) {
  regulatoryDocument(id: $regulatoryDocumentId) {
    ...RegDocFieldsForDocForm
    id
    clearingAuditLogs {
      id
    }
    createdAt
    modifiedAt
    modifiedBy {
      id
    }
    createdBy {
      id
    }
    finalVersionRef {
      id
    }
    status
    disassemblyStatus
    name
    summary
    documentStatus
    getexLink
    keywords {
      id
      name
      descriptions {
        lang
        translation
      }
      vkos {
        givenName
        id
        mail
        name
        surname
        userPrincipalName
      }
      vexClusters {
        id
        name
      }
    }
    regulation {
      id
      name
      regulationNumber
      regulatoryDocuments {
        ...FieldsToSelectRegDocInDocForm
      }
      markets {
        id
        name
        ...MarketNamingTemplateFields
      }
    }
    modelYear
    dateNewRegistration
    dateNewTypes
    dateEffective
    dateExpiration
    childrenRefs {
      id
    }
    workflow {
      status
      message
      processingVKO {
        ...UserFields
      }
      processingVKOExternal {
        ...UserFields
      }
      clearingVKO {
        ...UserFields
      }
      reapprovingVKO {
        ...UserFields
      }
      processingAuthor {
        ...UserFields
      }
      reapprovingAuthor {
        ...UserFields
      }
    }
    comments {
      id
      comment
      createdAt
      createdBy {
        ...UserFields
      }
      modifiedAt
      modifiedBy {
        ...UserFields
      }
    }
    faqs {
      id
      question
      answer
      createdAt
      createdBy {
        ...UserFields
      }
      modifiedAt
      modifiedBy {
        ...UserFields
      }
    }
    origin
    phaseIn {
      date
      status
    }
    phaseOut {
      date
      status
    }
    predecessors {
      id
      name
    }
    pogisExists
    pogisDocuments {
      id
      pogisId
    }
    documentReferences {
      documentReferenceGroup {
        regulatoryDocumentReferences {
          regulation {
            id
          }
        }
      }
    }
    documentSource {
      id
      name
    }
    getexLink
  }
}
    ${RegDocFieldsForDocFormFragmentDoc}
${FieldsToSelectRegDocInDocFormFragmentDoc}
${MarketNamingTemplateFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

/**
 * __useGetRegulatoryDocumentDetailsQuery__
 *
 * To run a query within a React component, call `useGetRegulatoryDocumentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulatoryDocumentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulatoryDocumentDetailsQuery({
 *   variables: {
 *      regulatoryDocumentId: // value for 'regulatoryDocumentId'
 *   },
 * });
 */
export function useGetRegulatoryDocumentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetRegulatoryDocumentDetailsQuery, GetRegulatoryDocumentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegulatoryDocumentDetailsQuery, GetRegulatoryDocumentDetailsQueryVariables>(GetRegulatoryDocumentDetailsDocument, options);
      }
export function useGetRegulatoryDocumentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegulatoryDocumentDetailsQuery, GetRegulatoryDocumentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegulatoryDocumentDetailsQuery, GetRegulatoryDocumentDetailsQueryVariables>(GetRegulatoryDocumentDetailsDocument, options);
        }
export type GetRegulatoryDocumentDetailsQueryHookResult = ReturnType<typeof useGetRegulatoryDocumentDetailsQuery>;
export type GetRegulatoryDocumentDetailsLazyQueryHookResult = ReturnType<typeof useGetRegulatoryDocumentDetailsLazyQuery>;
export type GetRegulatoryDocumentDetailsQueryResult = Apollo.QueryResult<GetRegulatoryDocumentDetailsQuery, GetRegulatoryDocumentDetailsQueryVariables>;
export const GetAuditLogEntityInfoDocument = gql`
    query GetAuditLogEntityInfo($endCursor: String, $fieldsFilter: [StringOperationFilterInput!]!) {
  auditLogs(
    where: {entityType: {eq: "RegulatoryDocument"}, change: {path: {or: $fieldsFilter}}}
    first: 50
    after: $endCursor
  ) {
    nodes {
      entityId
      entity {
        id
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetAuditLogEntityInfoQuery__
 *
 * To run a query within a React component, call `useGetAuditLogEntityInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogEntityInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditLogEntityInfoQuery({
 *   variables: {
 *      endCursor: // value for 'endCursor'
 *      fieldsFilter: // value for 'fieldsFilter'
 *   },
 * });
 */
export function useGetAuditLogEntityInfoQuery(baseOptions: Apollo.QueryHookOptions<GetAuditLogEntityInfoQuery, GetAuditLogEntityInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuditLogEntityInfoQuery, GetAuditLogEntityInfoQueryVariables>(GetAuditLogEntityInfoDocument, options);
      }
export function useGetAuditLogEntityInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuditLogEntityInfoQuery, GetAuditLogEntityInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuditLogEntityInfoQuery, GetAuditLogEntityInfoQueryVariables>(GetAuditLogEntityInfoDocument, options);
        }
export type GetAuditLogEntityInfoQueryHookResult = ReturnType<typeof useGetAuditLogEntityInfoQuery>;
export type GetAuditLogEntityInfoLazyQueryHookResult = ReturnType<typeof useGetAuditLogEntityInfoLazyQuery>;
export type GetAuditLogEntityInfoQueryResult = Apollo.QueryResult<GetAuditLogEntityInfoQuery, GetAuditLogEntityInfoQueryVariables>;
export const GetVexRegulatoryDocumentParagraphsDocument = gql`
    query GetVexRegulatoryDocumentParagraphs($regulatoryDocumentId: ID!, $inProcess: Boolean!) {
  vexRegulatoryDocumentParagraphs(
    regulatoryDocumentId: $regulatoryDocumentId
    inProcess: $inProcess
  ) {
    ...ParagraphFields
    keywordAssignments {
      keyword {
        id
        name
      }
      vexClusterAssignments {
        vexCluster {
          id
          name
        }
        keywordStatus
        keywordSuggestions {
          keyword {
            id
            name
            descriptions {
              lang
              translation
            }
          }
          suggestionNote
        }
      }
    }
  }
}
    ${ParagraphFieldsFragmentDoc}`;

/**
 * __useGetVexRegulatoryDocumentParagraphsQuery__
 *
 * To run a query within a React component, call `useGetVexRegulatoryDocumentParagraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVexRegulatoryDocumentParagraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVexRegulatoryDocumentParagraphsQuery({
 *   variables: {
 *      regulatoryDocumentId: // value for 'regulatoryDocumentId'
 *      inProcess: // value for 'inProcess'
 *   },
 * });
 */
export function useGetVexRegulatoryDocumentParagraphsQuery(baseOptions: Apollo.QueryHookOptions<GetVexRegulatoryDocumentParagraphsQuery, GetVexRegulatoryDocumentParagraphsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVexRegulatoryDocumentParagraphsQuery, GetVexRegulatoryDocumentParagraphsQueryVariables>(GetVexRegulatoryDocumentParagraphsDocument, options);
      }
export function useGetVexRegulatoryDocumentParagraphsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVexRegulatoryDocumentParagraphsQuery, GetVexRegulatoryDocumentParagraphsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVexRegulatoryDocumentParagraphsQuery, GetVexRegulatoryDocumentParagraphsQueryVariables>(GetVexRegulatoryDocumentParagraphsDocument, options);
        }
export type GetVexRegulatoryDocumentParagraphsQueryHookResult = ReturnType<typeof useGetVexRegulatoryDocumentParagraphsQuery>;
export type GetVexRegulatoryDocumentParagraphsLazyQueryHookResult = ReturnType<typeof useGetVexRegulatoryDocumentParagraphsLazyQuery>;
export type GetVexRegulatoryDocumentParagraphsQueryResult = Apollo.QueryResult<GetVexRegulatoryDocumentParagraphsQuery, GetVexRegulatoryDocumentParagraphsQueryVariables>;
export const GetAuditLogsDocument = gql`
    query GetAuditLogs($entityId: String!, $endCursor: String, $fieldsFilter: [StringOperationFilterInput!]!) {
  auditLogs(
    where: {entityId: {eq: $entityId}, change: {path: {or: $fieldsFilter}}}
    after: $endCursor
    first: 50
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      ...HistoryFields
    }
  }
}
    ${HistoryFieldsFragmentDoc}`;

/**
 * __useGetAuditLogsQuery__
 *
 * To run a query within a React component, call `useGetAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditLogsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      endCursor: // value for 'endCursor'
 *      fieldsFilter: // value for 'fieldsFilter'
 *   },
 * });
 */
export function useGetAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>(GetAuditLogsDocument, options);
      }
export function useGetAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>(GetAuditLogsDocument, options);
        }
export type GetAuditLogsQueryHookResult = ReturnType<typeof useGetAuditLogsQuery>;
export type GetAuditLogsLazyQueryHookResult = ReturnType<typeof useGetAuditLogsLazyQuery>;
export type GetAuditLogsQueryResult = Apollo.QueryResult<GetAuditLogsQuery, GetAuditLogsQueryVariables>;